import localforage from 'localforage';
import { StorageConstants } from '@linkie/shared';
import { usePlaygroundStore } from '../store/playground.store';
import { PlaygroundActionType } from '../types/playground-action.type';

export const resetPlaygroundSession = () => {
  const { dispatch } = usePlaygroundStore.getState();

  dispatch({ type: PlaygroundActionType.CLEAR_PAYLOAD });
  dispatch({ type: PlaygroundActionType.GET_LINKIE_USERNAMES, payload: [] });
  dispatch({ type: PlaygroundActionType.CLEAR_ACTIONS });

  return localforage.removeItem(StorageConstants.PLAYGROUND_STORE);
};
